module.exports = __webpack_public_path__ + "static/media/welcometofavela.08dbcbe7.mp4";